import React, { useContext, useEffect, useState } from 'react'; 
import { LangContext, MenuContext, PostContext } from '../context/DataContext';
import { TbEdit, TbMenu2, TbLogin, TbSettings, TbCalendarEvent ,  TbChevronDown } from "react-icons/tb";
import WebAppConfig from '../components/configuration/webapp-config';
import './AdminHeader.css';

const AdminHeader = () => { 
    const { isMenu } = useContext(MenuContext);
    const { data } = useContext(PostContext); 
    const { myLang } = useContext(LangContext);
    const [pageSetupID, setPageSetupID] = useState(null);
    const [showConfigMenu, setShowConfigMenu] = useState(false);
    
    const { config } = WebAppConfig();
    const currentEventID = config?.currentEventID;

    useEffect(() => {
        const fetchPageSetupID = async () => {
            if (!currentEventID) return;
            
            try {
                const response = await fetch(
                    `https://apievt.lacnic.net/wp-json/wp/v2/pages-setup?our_events=${currentEventID}`
                );
                const data = await response.json();
                if (data && data.length > 0) {
                    setPageSetupID(data[0].id);
                }
            } catch (error) {
                console.error('Error fetching page setup ID:', error);
            }
        };

        fetchPageSetupID();
    }, [currentEventID]);
     
    const id = data?.id;
    const editContentLink = `https://apievt.lacnic.net/wp-admin/post.php?post=${id}&action=edit&lang=${myLang}`;
    const menuId = isMenu?.term_id;
     // Links para editar y crear menú
     const editMenuLink = menuId ? 
     `https://apievt.lacnic.net/wp-admin/nav-menus.php?action=edit&menu=${menuId}&lang=${myLang}` : 
     `https://apievt.lacnic.net/wp-admin/nav-menus.php?action=edit&menu=0`;

 // Links para editar y crear configuración
 const configLink = pageSetupID ? 
     `https://apievt.lacnic.net/wp-admin/post.php?post=${pageSetupID}&action=edit&lang=${myLang}` : 
     `https://apievt.lacnic.net/wp-admin/post-new.php?post_type=pages-setup&lang=es`;
  
    return ( 
        <div className="admin-edit-bar">
            <div className="admin-edit-container">
                <div className="admin-left">
                    <span className="admin-environment-label">
                        {window.location.hostname === 'localhost' ? 'Entorno de prueba web eventos' : 'Test'} 
                    </span>
                    <span className="admin-post-id"> 
                        {data?.title?.rendered || ''}
                    </span>
                </div>
                <div className="admin-buttons">
                    <a 
                        href={editContentLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="admin-edit-button"
                        title="Editar Contenido"
                    >
                        <TbEdit className="admin-icon" />
                        <span>Editar Contenido</span>
                    </a>
                    <a 
                        href={editMenuLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="admin-edit-button menu"
                        title={menuId ? "Editar Menú" : "Crear Nuevo Menú"}
                    >
                        <TbMenu2 className="admin-icon" />
                        <span>{menuId ? "Editar Menú" : "Crear Menú"}</span>
                    </a>
                    <div className="admin-dropdown" onMouseLeave={() => setShowConfigMenu(false)}>
                        <button 
                            className="admin-edit-button config"
                            onMouseEnter={() => setShowConfigMenu(true)}
                            title="Configuración General"
                        >
                            <TbSettings className="admin-icon" />
                            <span>Configuración</span>
                            <TbChevronDown className="admin-icon-small" />
                        </button>
                        {showConfigMenu && (
                            <div className="admin-dropdown-menu">
                                <a 
                                    href={configLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="admin-dropdown-item"
                                    title={pageSetupID ? 
                                        "Configurar páginas y secciones del evento actual" : 
                                        "Crear nueva configuración de páginas"}
                                >
                                    <TbSettings className="admin-icon" />
                                    <span>{pageSetupID ? 
                                        "Configurar Páginas" : 
                                        "Nueva Configuración"}
                                    </span>
                                </a>
                                <a 
                                    href="https://apievt.lacnic.net/wp-admin/edit-tags.php?taxonomy=our_events"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="admin-dropdown-item"
                                    title="Gestionar eventos de LACNIC"
                                >
                                    <TbCalendarEvent className="admin-icon" />
                                    <span>Gestionar Eventos</span>
                                </a>
                            </div>
                        )}
                    </div>
                    <a 
                        href="https://apievt.lacnic.net/login"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="admin-edit-button login"
                        title="Acceder a WordPress"
                    >
                        <TbLogin className="admin-icon" />
                        <span>Acceder</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default AdminHeader;